import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DataService } from "src/app/services/data.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { createDemandeLicence, createDemandeLicenceFailure, createDemandeLicenceSuccess, deleteDemandeLicence, deleteDemandeLicenceFailure, deleteDemandeLicenceSuccess, getAllDemandeLicence, getAllDemandeLicenceFailure, getAllDemandeLicenceSuccess } from "../actions/demande-licence.action";
import { catchError, concatMap, exhaustMap, map, of, tap } from "rxjs";

@Injectable()
export class DemandeLicenceEffect {

  loadDemandeLicences$ = createEffect(() => this.actions$.pipe(
    ofType(getAllDemandeLicence),
    exhaustMap(({ element, page, size, utilisateurId }) => this.dataService.loadDemandeLicenceData(element, page, size, utilisateurId).pipe(
      map((reponseDAO) => getAllDemandeLicenceSuccess(reponseDAO)),
      catchError((error) => of(getAllDemandeLicenceFailure({ error })))
    ))
  ))

  createDemandeLicence$ = createEffect(() => this.actions$.pipe(
    ofType(createDemandeLicence),
    exhaustMap(({ demandeLicence }) => this.dataService.createObject('DemandeLicence', demandeLicence).pipe(
      map((reponseDAO) => createDemandeLicenceSuccess(reponseDAO)),
      catchError((error) => of(createDemandeLicenceFailure({ error })))
    )),
    tap((action) => {
      if (action.type === '[DemandeLicence] Create Demande Licence Success') {
        this.notificationService.success("Demande de licence ajouté avec succès !");
      }
    })
  ))

  deleteDemandeLicence$ = createEffect(() => this.actions$.pipe(
    ofType(deleteDemandeLicence),
    concatMap(({ id }) => this.dataService.deleteDemandeLicence(id).pipe(
      map(() => deleteDemandeLicenceSuccess()),
      catchError((error) => of(deleteDemandeLicenceFailure({ error })))
    )
    ),
    tap((action) => {
      if (action.type === "[DemandeLicence] Delete Demande Licence Success") {
        this.notificationService.success("Demande de licence supprimée")
      } else {
        this.notificationService.error("Erreur lors de la suppression de la demande de licence")
      }
    })
  ))

  constructor(private actions$: Actions, private notificationService: NotificationService, private router: Router, private dataService: DataService) { }
}
